import '../css/applyCredit.css'
import { useEffect, useState } from 'react'
import TodayDay from '../utils/TodayDay'
import Swal from 'sweetalert2'
import { UltimoCredito, getTipoCreditos } from '../service/creditos'
import { solicitarCredito } from '../service/solicitud'


const ApplyCredit = ({ client , credits}) => {
    const [selectedCategory, setSelectedCategory] = useState(1)
    const [categoryCredit, setCategoryCredit] = useState([])
    const [montoSolicitado, setMontoSolicitado] = useState('')
    const [montoAnterior, setMontoAnterior] = useState(0)
    const [destinoCredito, setDestinoCredito] = useState('')
    const [fechaDesembolso, setFechaDesembolso] = useState('')
    const [telefono, setTelefono] = useState('')
    const [tipoCredito, setTipoCredito] = useState('')
    const [lastCredit, setLastCredit] = useState('')
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    
    
    // funcion para guardar la categoria de credito
    const handleTypeCategory = (event) => {
        const category = event.target.value;
        setSelectedCategory(category);
    };
    
    // useEffect para obtener el ultimo credito
    useEffect(() => {
        const lastCredit =  async () => {
            try {
                const data = await UltimoCredito();
                
                setLastCredit(data)
            }catch (error) {
                console.error('Error en la solicitud:', error);
            }
        };
        lastCredit();
    },[])
    
    // useEffect para obtener el tipo de credito
    useEffect(() => {
        const getTypeCredit = async () => {
            try {
                const data = await getTipoCreditos(selectedCategory);
                if (Array.isArray(data)) {
                    setCategoryCredit(data);
                } else {
                    console.error('La respuesta de la API no es un array:', data);
                    setCategoryCredit([]);
                }
            } catch (error) {
                console.error('There has been a problem with your fetch operation:', error);
            }
        };

        getTypeCredit();
    }, [selectedCategory]);
    
    // useEffect para llenar campos de solicitud
    useEffect(() => {
        if (lastCredit) {
            // calculando el ultimo monto solicitado
            const calc = (lastCredit.monto_pagar - lastCredit.interes_total).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            
            // asignando valores de tipo de credito y categoria de ultimo_credito
            const idCategoriaCredito = lastCredit.Desembolso.Solicitud.TipoCredito.id_categoria_credito;
            const idCategoryCredit = lastCredit.Desembolso.Solicitud.TipoCredito.id_tipo_credito

            setMontoAnterior(calc);
            setSelectedCategory(idCategoriaCredito)
            setTipoCredito(idCategoryCredit)
            setTelefono(client.telefono)


            // calculando la fecha de desembolso si ha terminado el credito o si esta activo
            if (lastCredit && lastCredit.fecha_final_prevista) {
                const fechaPrevista = new Date(lastCredit.fecha_final_prevista); // Convertir fecha prevista a objeto Date
                const fechaActual = new Date(); // Fecha actual
                let Fecha_Desembolso
    
                if (fechaPrevista < fechaActual) {
                    Fecha_Desembolso = fechaActual.toISOString().split('T')[0]  // Si la fecha ha pasado
                } else {
                    Fecha_Desembolso = fechaPrevista.toISOString().split('T')[0] // Si la fecha no ha pasado
                }
                setFechaDesembolso(Fecha_Desembolso)
            }

        } else {
            setMontoAnterior("0.00");
        }
    }, [lastCredit]);

    // funcion para envio de datos para solicitar credito
    const handleSubmit = async () => {
        try {
           
            const date = TodayDay()

            // creando arreglo para llenar campos de tabla solicitudes
            const object = {
                id_cliente: client.codigo,
                    ultimo_credito: lastCredit.codigo,
                    ultimo_monto: parseFloat(montoAnterior),
                    monto_solicitado: parseFloat(montoSolicitado),
                    categoria_credito: selectedCategory,
                    tipo_credito: tipoCredito,
                    destino: destinoCredito,
                    fecha_desembolso: fechaDesembolso,
                    telefono: telefono,
                    fecha_creacion: date,
                    estado: 1
            }

            const response = await solicitarCredito(object);

            if (response.ok) {
                // Si la respuesta es exitosa
                Swal.fire({
                    title: 'Ingreso Exitoso',
                    text: 'Los datos han sido ingresados correctamente.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    // Recargar la página después de cerrar la alerta
                    window.location.reload()
                });
            } else {
                // Manejar un error en la solicitud
                const errorData = await response.json()
                Swal.fire({
                    title: 'Error',
                    text: `Ocurrió un error: ${errorData.message}`,
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
           
        } catch (error) {
            console.error('Error en la solicitud:', error)
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error inesperado.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
    }

    return (
        <div className="container-creditApply">
            <h1>Solicitud de Préstamo</h1>
            <br />
    
            {/* Monto Solicitado y Monto del Último Crédito en la misma fila */}
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="montoSolicitado">Monto Solicitado</label>
                    <div className="input-group">
                        <span className="input-group-addon">$</span>
                        <input
                            type="text"
                            min="0"
                            className="form-control"
                            placeholder="0.00"
                            value={montoSolicitado}
                            onChange={(e) => setMontoSolicitado(e.target.value)}
                        />
                    </div>
                </div>
    
                <div className="form-group">
                    <label htmlFor="montoAnterior">Monto del Último Crédito</label>
                    <div className="input-group">
                        <span className="input-group-addon">$</span>
                        <input
                            type="text"
                            min="0"
                            className="form-control"
                            placeholder="0.00"
                            value={montoAnterior}
                            readOnly
                            disabled
                        />
                    </div>
                </div>
            </div>
    
            {/* Categoría del Crédito y Tipo de Crédito en la misma fila */}
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="categoriaCredito">Categoría del Crédito</label>
                    <select
                        onChange={handleTypeCategory}
                        className="form-control"
                        value={selectedCategory}
                    >
                        <option value="1">Tradicional</option>
                        <option value="2">Plus</option>
                        <option value="3">Flash</option>
                        <option value="7">Estacionario</option>
                    </select>
                </div>
    
                <div className="form-group">
                    <label htmlFor="tipoCredito">Tipo de Crédito</label>
                    <select
                        className="form-control"
                        value={tipoCredito}
                        onChange={(e) => setTipoCredito(e.target.value)}
                    >
                        <option value="">Seleccione una categoría</option>
                        {Array.isArray(categoryCredit) && categoryCredit.length > 0 ? (
                            categoryCredit.map((category, index) => (
                                <option key={index} value={category.id_tipo_credito}>
                                    {category.nombre}
                                </option>
                            ))
                        ) : (
                            <option value="">No hay tipos de crédito disponibles</option>
                        )}
                    </select>
                </div>
            </div>
    
            {/* Destino del Crédito ocupa toda la fila */}
            <div className="form-group">
                <label htmlFor="destinoCredito">Destino del Crédito</label>
                <textarea
                    className="form-control"
                    style={{ height: '100px' }}
                    value={destinoCredito}
                    onChange={(e) => setDestinoCredito(e.target.value)}
                />
            </div>
    
            {/* Fecha de desembolso y Teléfono en la misma fila */}
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="fechaDesembolso">Fecha Aproximada de Desembolso</label>
                    <input
                        type="date"
                        className="form-control"
                        value={fechaDesembolso}
                        onChange={(e) => setFechaDesembolso(e.target.value)}
                    />
                </div>
    
                <div className="form-group">
                    <label htmlFor="telefono">Teléfono</label>
                    <input
                        type="text"
                        className="form-control"
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                        placeholder="ej: 7582-2541"
                    />
                </div>
            </div>
    
            {/* Botón de enviar */}
            <button className="btn btn-primary" onClick={handleSubmit}>
                Solicitar Crédito
            </button>
        </div>
    );    
}

export default ApplyCredit
